/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReferralOverviewDto
 */
export interface ReferralOverviewDto {
    /**
     * 
     * @type {boolean}
     * @memberof ReferralOverviewDto
     */
    hasProfile: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReferralOverviewDto
     */
    linkActive: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReferralOverviewDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReferralOverviewDto
     */
    referralUrl?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReferralOverviewDto
     */
    availableCreditCzk: number;
    /**
     * 
     * @type {number}
     * @memberof ReferralOverviewDto
     */
    pendingCreditCzk: number;
    /**
     * 
     * @type {number}
     * @memberof ReferralOverviewDto
     */
    totalEarnedCzk: number;
    /**
     * 
     * @type {number}
     * @memberof ReferralOverviewDto
     */
    totalUsedCzk: number;
}

export function ReferralOverviewDtoFromJSON(json: any): ReferralOverviewDto {
    return ReferralOverviewDtoFromJSONTyped(json, false);
}

export function ReferralOverviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralOverviewDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hasProfile': json['hasProfile'],
        'linkActive': json['linkActive'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'referralUrl': !exists(json, 'referralUrl') ? undefined : json['referralUrl'],
        'availableCreditCzk': json['availableCreditCzk'],
        'pendingCreditCzk': json['pendingCreditCzk'],
        'totalEarnedCzk': json['totalEarnedCzk'],
        'totalUsedCzk': json['totalUsedCzk'],
    };
}

export function ReferralOverviewDtoToJSON(value?: ReferralOverviewDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hasProfile': value.hasProfile,
        'linkActive': value.linkActive,
        'code': value.code,
        'referralUrl': value.referralUrl,
        'availableCreditCzk': value.availableCreditCzk,
        'pendingCreditCzk': value.pendingCreditCzk,
        'totalEarnedCzk': value.totalEarnedCzk,
        'totalUsedCzk': value.totalUsedCzk,
    };
}

